
<script>
  import { Bar } from 'vue-chartjs'
 
  export default {
    extends: Bar,
    props: ['data', 'options'],

    mounted () {
      this.renderChart(this.data, this.options);
    },

		methods: {
		 printBarGraphe(){
		 	let imageValue = this.$refs.canvas.toDataURL()

      var downloadLink = document.createElement('a');
			downloadLink.href = imageValue;
			downloadLink.download = 'Graphe_bar.png';

			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		 },		 
		}
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/BarChart.vue